import { Navigate } from 'react-router';
import { useAuth } from '../hooks/useAuth';
import { en } from '@seedgovernance/shared';
import { MARKETING_URL } from '../lib/constants';

export function Login() {
  const { isAuthenticated, isLoading, login } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-surface-dark">
        <div className="w-10 h-10 border-3 border-brand border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-surface-dark">
      <div className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-6">
            <svg viewBox="0 0 32 32" fill="none" className="w-10 h-10">
              <rect x="2" y="2" width="28" height="28" rx="6" fill="#6c5ce7" />
              <path d="M10 19L16 13L22 19" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M10 24L16 18L22 24" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
            </svg>
            <span className="text-2xl font-display font-bold">
              <span className="text-brand">{en.brand.name.slice(0, 4)}</span>
              <span className="text-slate-300">{en.brand.name.slice(4)}</span>
            </span>
          </div>
          <h1 className="text-xl font-display font-semibold text-white mb-2">
            {en.brand.tagline}
          </h1>
          <p className="text-slate-400 text-sm">
            Sign in to your compliance portal
          </p>
        </div>

        <button
          onClick={() => login()}
          className="w-full py-3 px-6 bg-brand hover:bg-brand-dark text-white font-semibold rounded-lg transition-colors"
        >
          Sign In
        </button>

        <p className="text-center text-slate-500 text-xs mt-6">
          Don't have an account?{' '}
          <a
            href={`${MARKETING_URL}/assessment`}
            className="text-brand-light hover:text-brand"
          >
            Take the free assessment
          </a>
        </p>
      </div>
    </div>
  );
}
